function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
import { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '../styles';
import Tooltip from '../Tooltip';
import Fade from '../Fade';
const PixelTooltip = styled(_ref => {
  let {
    className,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Tooltip, _extends({}, props, {
    arrow: true,
    classes: {
      popper: className
    },
    TransitionComponent: Fade,
    TransitionProps: {
      timeout: 300
    }
  }));
})(_ref2 => {
  let {
    theme
  } = _ref2;
  return {
    ["& .".concat(tooltipClasses.arrow)]: {
      color: theme.palette.common.white
    },
    ["& .".concat(tooltipClasses.tooltip)]: {
      backgroundColor: theme.palette.background.default,
      boxShadow: theme.shadows[5],
      color: theme.palette.text.secondary,
      typography: theme.typography.body2
    }
  };
});
const StandardTooltip = _ref3 => {
  let {
    title,
    children,
    arrowDirection = "top",
    arrow = true,
    leaveDelay,
    enterDelay,
    ...restProps
  } = _ref3;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PixelTooltip, _extends({
    title: title,
    placement: arrowDirection,
    arrow: arrow,
    leaveDelay: leaveDelay,
    enterDelay: enterDelay
  }, restProps), /*#__PURE__*/React.createElement("span", null, children)));
};
export default StandardTooltip;